<template>
  <div class="nom-wrapper">
    <div class="nom-card">
      <!-- Mobil: bară de secțiuni scrollabilă în loc de taburi verticale -->
      <div v-if="isMobile" class="nom-chips">
        <button v-for="(t, i) in tabs" :key="i" class="nom-chip"
          :class="{ active: selectedIndex === i }" @click="setTab(i)">{{ t.text }}</button>
      </div>
      <div class="tabs-container" :class="{ 'is-mobile': isMobile }">
        <DxTabs v-if="!isMobile" :data-source="tabs" :selected-index="selectedIndex" orientation="vertical"
          class="tabs" @option-changed="onTabChanged" />
        <div class="tab-content">
          <MarciModele v-if="selectedIndex === 0" />
          <GridNomenclatorPam v-else-if="selectedIndex === 1" entity="PAM_Stare" title="Stare" />
          <GridNomenclatorPam v-else-if="selectedIndex === 2" entity="PAM_TipCombustibil" title="Tip Combustibil" />
          <GridNomenclatorPam v-else-if="selectedIndex === 3" entity="PAM_TipProprietate" title="Tip Proprietate" />
          <GridNomenclatorPam v-else-if="selectedIndex === 4" entity="PAM_TipAsigurare" title="Tip Asigurare" />
          <GridNomenclatorPam v-else-if="selectedIndex === 5" entity="PAM_Valabilitate" title="Valabilitate" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { DxTabs } from "devextreme-vue/tabs";
import GridNomenclatorPam from "./GridNomenclatorPam.vue";
import MarciModele from "./MarciModele.vue";

export default defineComponent({
  name: "NomenclatoareParcAuto",
  components: { DxTabs, GridNomenclatorPam, MarciModele },
  data() {
    return {
      selectedIndex: 0,
      isMobile: window.matchMedia("(max-width: 768px)").matches,
      tabs: [
        { text: "Mărci & Modele" },
        { text: "Stare" },
        { text: "Tip Combustibil" },
        { text: "Tip Proprietate" },
        { text: "Tip Asigurare" },
        { text: "Valabilitate" },
      ],
    };
  },
  methods: {
    setTab(i: number) {
      this.selectedIndex = i;
      this.$router.replace({ query: { ...this.$route.query, subTab: i } }).catch(() => {});
    },
    onTabChanged(e: any) {
      if (e.name !== "selectedIndex") return;
      const idx = e.component.option("selectedIndex");
      if (idx != null && idx >= 0) this.selectedIndex = idx;
      this.$router.replace({ query: { ...this.$route.query, subTab: this.selectedIndex } }).catch(() => {});
    },
  },
  mounted() {
    if (this.$route.query.subTab) this.selectedIndex = Number(this.$route.query.subTab);
  },
});
</script>

<style scoped>
.nom-wrapper { padding: 16px; height: 100%; display: flex; flex-direction: column; background: #f8f9fc; }
.nom-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}
.tabs-container { display: flex; flex: 1; min-height: 0; padding: 12px 18px; }
.tabs { flex-shrink: 0; }
.tab-content { flex: 1; min-width: 0; height: 100%; padding-left: 12px; }

/* ---- Mobil ---- */
.tabs-container.is-mobile { padding: 0; }
.tabs-container.is-mobile .tab-content { padding-left: 0; }
.nom-chips {
  flex-shrink: 0;
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding: 10px 12px;
  border-bottom: 1px solid #e5e7eb;
}
.nom-chips::-webkit-scrollbar { display: none; }
.nom-chip {
  flex: 0 0 auto;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #475569;
  border-radius: 20px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
}
.nom-chip.active { background: linear-gradient(90deg, #ff2c21, #ff6a4a); border-color: transparent; color: #fff; }
</style>
